import { useEffect, useRef } from 'react';
import Clarity from '@microsoft/clarity';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook that tracks route changes and fires Clarity events
 * @returns void - this hook doesn't return anything, it just handles side effects
 */
const useRouteTracker = (): void => {
  const location = useLocation();
  const previousPathRef = useRef<string>('');

  useEffect(() => {
    const currentPath = location.pathname;

    // Only fire event if the path has actually changed
    if (currentPath !== previousPathRef.current) {
      // Get route name from path (remove leading slash and use as event name)
      const routeName = currentPath === '/' ? 'home' : currentPath.substring(1).replace(/\//g, '-');

      // Fire Clarity event with route name
      Clarity.event(routeName);

      // Update previous path reference
      previousPathRef.current = currentPath;
    }
  }, [location.pathname]);
};

export default useRouteTracker;
